import { Preferences } from "@capacitor/preferences";

export const setUser = async (user) => {
  await Preferences.set({
    key: "user",
    value: JSON.stringify(user),
  });
};

export const getUser = () => {
  return Preferences.get({ key: "user" }).then(({ value }) => {
    return value ? JSON.parse(value) : null;
  });
};

export const removeCookie = async (key) => {
  await Preferences.remove({ key: key });
};


export const getUniqueDataById = (prevData, newData, idKey = "id") => {
  const combinedData = [...prevData, ...newData];
  const uniqueDataMap = new Map();

  combinedData.forEach((item) => {
    uniqueDataMap.set(item[idKey], item);
  });

  return Array.from(uniqueDataMap.values());
};

// Helper to capitalize each word
export const toProperCase = (str) => {
  if (!str) return "N/A";
  return str
    .toLowerCase()
    .replace(/_/g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export function formatDateTime(timestamp) {
  const date = new Date(timestamp);
  return date.toLocaleString("en-IN", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

export const getLabel = (list, value) => {
  if (!Array.isArray(list)) return value;
  const found = list.find((item) => item.value === value);
  return found ? found.label : value;
};

export function getFormatDate(dateStr) {
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear()).slice(-2);
  return `${day}/${month}/${year}`;
};

export const formatDateDDMMYYYY = (dateStr) => {
  if (!dateStr) return "";
  return dateStr.split("-").reverse().join("-");
};



